module.exports = __webpack_public_path__ + "static/media/publish-videos-images-tabletPro-en.8f3b0dcf.png";